import bodyText from '../../../../fixtures/scenario-center/highrise-st-body.json?raw';
import provenanceText from '../../../../fixtures/scenario-center/highrise-st-provenance.json?raw';
import { freezeSource, isObject, projectScenario } from '../domain/projection';
import type { ScenarioObservation, ScenarioProvenance } from '../domain/types';
export const scenarioProvenance = freezeSource(JSON.parse(provenanceText) as ScenarioProvenance);
/** Bundled fixed Git source only. No network or backend availability claim. */
export function loadSourceBoundScenario(): ScenarioObservation {
  try {
    const body: unknown = JSON.parse(bodyText);
    if (!isObject(body)) throw new Error('Body unavailable');
    return { status: 'AVAILABLE', data: projectScenario(body, scenarioProvenance) };
  } catch {
    return {
      status: 'SOURCE_UNAVAILABLE',
      message: 'Fixed ScenarioTemplate source cannot be read. No fallback content is substituted.',
    };
  }
}
